var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"left":""}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v(" Policy Info ")]),_c('v-tab-item',[_c('ri-Quick-Info')],1),_c('v-tab',{attrs:{"ripple":""}},[_vm._v(" Cedant Info ")]),_c('v-tab-item',[_c('ri-cedant-info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }